import React from 'react';
import PropTypes from 'prop-types';

function joinDefinitions(svgs) {
    let definitions = '';

    Object.keys(svgs).forEach((def) => {
        definitions += svgs[def];
    });

    return {__html: definitions};
}

function SVGDefinitions({children, data}) {
    return (
        <svg
            width="0"
            height="0"
            style={{display: 'none'}}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            {!data.loading && (
                // eslint-disable-next-line react/no-danger
                <defs dangerouslySetInnerHTML={joinDefinitions(data.svgs)} />
            )}
            <defs>{children}</defs>
        </svg>
    );
}

SVGDefinitions.propTypes = {
    /** GraphQL Data for SVG Definitions */
    data: PropTypes.shape({
        loading: PropTypes.bool,
        svgs: PropTypes.objectOf(PropTypes.string)
    }).isRequired
};

SVGDefinitions.defaultProps = {
    data: {
        svgs: {}
    }
};

export default SVGDefinitions;
